module.exports = __webpack_public_path__ + "static/media/case7.fd27af82.jpg";